import { useCallback } from 'react';
import { store } from 'Utilities/store';
import { sharingCodeValidateService } from 'Services/libre_api';
const useCommercialApi = () => {
    const sharingCodeValidate = useCallback(async (code, yearOfBirth) => {
        const { user } = store.getState().auth;
        const { osType, osVersion, app, appVersion } = store.getState().env;
        await sharingCodeValidateService(code, yearOfBirth, user.id, osType, osVersion, app, appVersion);
    }, []);
    return { sharingCodeValidate };
};
export default useCommercialApi;
